import { Button } from "@chakra-ui/react";
import { useMemo, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { ErrorEntity } from "../../root/context";
import useApiRequest from "../../../lib/hooks/useRequest";

const EmailVerificationStep = ({ onContinue }: { onContinue: () => Promise<void> }) => {
  const { apiRequest } = useApiRequest();
  const [searchParams] = useSearchParams();
  const [isChecking, setIsChecking] = useState(false);
  const [confirmError, setConfirmError] = useState<string | null>(null);

  const mail = useMemo(() => searchParams.get("mail"), [searchParams]);

  const resendMail = async () => {
    await apiRequest("users/resend-email-verification", "POST", {
      toast: {
        toastText: "Email wurde erneut gesendet",
      },
    });
  };

  const handleConfirmedClick = async () => {
    setIsChecking(true);
    setConfirmError(null);

    const res = await apiRequest("users/userinfo", "GET");

    if (res.data) {
      await onContinue();
      setIsChecking(false);
      return;
    }

    const errorObj = res.error as any;
    const isStillNotVerified =
      errorObj?.entity === ErrorEntity.EMailNotVerifiedForbidden || errorObj?.error === ErrorEntity.EMailNotVerifiedForbidden;

    if (isStillNotVerified) {
      setConfirmError("Die E-Mail ist noch nicht verifiziert. Bitte warten Sie kurz und versuchen Sie es erneut.");
      setIsChecking(false);
      return;
    }

    await onContinue();
    setIsChecking(false);
  };

  return (
    <div className="w-full flex justify-center">
      <div className="w-full max-w-xl">
        <div className="bg-white p-8 rounded-lg flex flex-col gap-4 border border-gray-200 shadow-sm">
          <h3 className="text-2xl font-semibold text-center">Email-Bestätigung</h3>
          <h4 className="text-lg text-center">Eine Email wurde an {mail ?? "Ihre Mail"} gesendet</h4>
          <p className="text-center text-gray-600">
            Um Zugriff auf alle Funktionen zu erhalten, bestätigen Sie bitte Ihre Email-Adresse. Überprüfen Sie Ihren
            Posteingang und klicken Sie auf den Bestätigungslink. Schauen Sie auch in Ihrem Spam-Ordner nach.
          </p>
          {confirmError && <p className="text-center text-sm text-red-600">{confirmError}</p>}
          <div className="flex flex-col gap-2 pt-2">
            <Button colorScheme="primary" color="white" className="w-full" onClick={resendMail}>
              Email erneut senden
            </Button>
            <Button variant="outline" className="w-full" onClick={handleConfirmedClick} isLoading={isChecking}>
              Ich habe bestätigt
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EmailVerificationStep;

